import { Menu as MenuIcon } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Select, SelectChangeEvent, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ui } from "../i18n";
import { LayoutState, MediaQueryFixMargin, MediaQueryMobile, MediaQueryScaleMargin, MediaQueryShallow } from "../Layout";
import { changeLang } from "../state/Language";
import { RootState } from "../store";
import MainNavigationItemMobile from "./MainNavigationItemMobile";

export default function MainNavigationMobile() {
    // Init layout parameters
    const layoutState = new LayoutState();
    layoutState.fixMargin = useMediaQuery(MediaQueryFixMargin);
    layoutState.scaleMargin = useMediaQuery(MediaQueryScaleMargin);
    layoutState.isMobile = useMediaQuery(MediaQueryMobile);
    layoutState.isShallow = useMediaQuery(MediaQueryShallow);

    // Determine UI language
    const lang = useSelector((state: RootState) => state.language.value);

    // Handle language change
    const dispatch = useDispatch();
    const handleChange = (event: SelectChangeEvent) => {
        dispatch(changeLang(event.target.value as string));
        window.krlang = event.target.value;
    };

    // Handle menu actions
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{
            position: layoutState.MobileMenuPosition(), top: layoutState.MobileMenuTop(), left: layoutState.MobileMenuLeft(), paddingBottom: "40px", paddingLeft: layoutState.MobileMenuPaddingLeft(), 
            zIndex: layoutState.MobileMenuZIndex()
        }}>
            <IconButton
                size="large"
                edge="start"
                onClick={handleClick}
            >
                <MenuIcon sx={{ height: "20px"}}/>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.about} path="about" callback={handleClose} />
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.artist} path="artist" callback={handleClose} />
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.art} path="art" callback={handleClose} />
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.galleryall} path="gallery/all" callback={handleClose} />
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.booksall} path="books" callback={handleClose} />
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.virtualtour} path="virtualtour" callback={handleClose} />
                {false &&
                    <MainNavigationItemMobile name="Künstlerbücher" path="" callback={handleClose} />
                }
                <MainNavigationItemMobile name={ui[lang].MainNavigationItem.visit} path="visit" callback={handleClose} />
                <MenuItem dense>
                    <Typography variant="subtitle1" sx={{ margin: 0, padding: 0, marginRight: "10px" }}>
                        {ui[lang].MainNavigationItem.lang}:
                    </Typography>
                    <Select sx={{}} variant="standard"
                        value={lang}
                        disableUnderline
                        onChange={handleChange}>
                        <MenuItem sx={{}} value={"de"}>DE</MenuItem>
                        <MenuItem value={"en"}>EN</MenuItem>
                    </Select>
                </MenuItem>
            </Menu>
        </Box>
    );
}